import { MercurePrivateChannel } from "./mercure-private-channel";

/** A fail-closed JWE channel whose key and whisper contents remain hidden from the hub. */
export class MercureEncryptedPrivateChannel extends MercurePrivateChannel {}
